// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-button[data-v-2eeae1ab]{min-width:250px}.upload-section[data-v-2eeae1ab]{display:flex;gap:20px}@media(max-width:575px){.upload-section[data-v-2eeae1ab]{flex-direction:column}}", ""]);
// Exports
module.exports = exports;
